var _path, _path2;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgPerson(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 14,
    height: 16,
    viewBox: "0 0 14 16",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M3.38505 10.3549C2.44187 10.9165 -0.0310903 12.0633 1.47511 13.4982C2.21087 14.1992 3.03033 14.7005 4.06058 14.7005L9.93942 14.7005C10.9697 14.7005 11.7891 14.1992 12.5249 13.4982C14.0311 12.0633 11.5581 10.9165 10.615 10.3549C8.40321 9.03795 5.59679 9.03795 3.38505 10.3549Z",
    stroke: "#A2A2B8",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M10 4.36719C10 6.02404 8.65685 7.36719 7 7.36719C5.34315 7.36719 4 6.02404 4 4.36719C4 2.71033 5.34315 1.36719 7 1.36719C8.65685 1.36719 10 2.71033 10 4.36719Z",
    stroke: "#A2A2B8"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgPerson);
export default __webpack_public_path__ + "static/media/person.a8c67983b9febdb75a48dd5e07717c29.svg";
export { ForwardRef as ReactComponent };